function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2611 6.00003C49.0321 6.00003 56.9527 13.7915 56.9527 23.401C56.9527 33.013 49.0321 40.8045 39.2611 40.8045C29.4902 40.8045 21.5696 33.013 21.5696 23.401C21.5696 13.789 29.4926 6.00003 39.2611 6.00003ZM39.2611 6.00003C49.0321 6.00003 56.9527 13.7915 56.9527 23.401C56.9527 33.013 49.0321 40.8045 39.2611 40.8045C29.4902 40.8045 21.5696 33.013 21.5696 23.401C21.5696 13.789 29.4926 6.00003 39.2611 6.00003ZM32.6271 44.9952H47.373C59.9953 44.9952 70.2257 55.0568 70.2257 67.4729V68.9209C70.2257 73.8138 59.9928 74.0001 47.373 74.0001H32.6271C20.0048 74.0001 9.77435 73.9927 9.77435 68.9209V67.4729C9.77435 55.0568 20.0048 44.9952 32.6271 44.9952Z"
});

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/IconUser.90240fc2.svg";
export { ForwardRef as ReactComponent };